<template>

<b-modal :id="modalId" @hidden="onHidden" @ok="$emit('save', client)" title="Nuevo Cliente" size="lg" header-bg-variant="success" header-text-variant="light"
         ok-title="Guardar" ok-variant="success" cancel-title="Cancelar">
  <client-form v-model="client"/>
</b-modal>

</template>

<script>

import ClientForm from './ClientForm'

export default {
  name: 'AddClientModal',
  components: {ClientForm},
  props: {
    modalId: {type: String, required: true}
  },
  data() {
    return {
      client: {}
    }
  },
  methods: {
    onHidden() {
      this.client = {}
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/client/AddClientModal.vue